import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'

import * as types from '../../constants'
import SemanticUiModal from '../../components/modal';
import ElementLoader from '../../components/element_loader';
import LibraryControlForm from './library_control_form';
import { getText } from '../../helpers';

import 'semantic-ui-css/semantic.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../App.css';

function CreateActions(props) {
  return (
    <div>
      <Button size='medium' className="close-button" onClick={props.hideCreateControl}>
        {getText("Cancel")}
      </Button>
      <Button positive size='medium' className="save-control-button" onClick={props.createLibraryControl} disabled={props.isLoading}>
        {getText("Save")}
        <div className="position-relative">
          <ElementLoader isLoading={props.isLoading} message=" " />
        </div>
      </Button>
    </div>
  )
}

export default class CreateLibraryControl extends Component {
  constructor(props){
    super(props);
  
    this.state = {
      isLoading: false
    }
  }

  createLibraryControl = () => {
    this.setState({ isLoading: true }, this.props.createLibraryControl)
  }

  componentWillReceiveProps = (nextProps) => {
    if(types.CREATE_LIBRARY_CONTROL_FAILURE === nextProps.actionType) {
      this.setState({ isLoading: false })
    }
  };

  render() {
    const modalOptions = { className: "create-control", size: "tiny" }
    return (
      <SemanticUiModal
        modalOptions={modalOptions}
        header={getText("Add New Library Control")}
        content={
          <LibraryControlForm
            control={this.props.control}
            controlErrors={this.props.controlErrors}
            handleControlChange={this.props.handleControlChange}
            defaultTagOptions={this.props.defaultTagOptions}
            defaultOwnerOptions={this.props.defaultOwnerOptions}
            updateOwners={this.props.updateOwners}
            createNewOwner={this.props.createNewOwner}
            removeOwner={this.props.removeOwner}
            updateTags={this.props.updateTags}
            createNewTag={this.props.createNewTag}
            removeTag={this.props.removeTag}
            translations={this.props.translations}
          />
        }
        actions={
          <CreateActions
            hideCreateControl={this.props.hideCreateControl}
            createLibraryControl={this.createLibraryControl}
            isLoading={this.state.isLoading}
          />
        }
        closeModal={this.props.hideCreateControl}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/control_library/create_library_control.js